export enum DomesticPartnerFormAction {
	ESTABLISH = 'ESTABLISH',
	DISSOLUTION = 'DISSOLUTION',
	DEATH = 'DEATH',
}
export interface DomesticPartnerFormModel  {
    formAction: DomesticPartnerFormAction,
    end_date: string;
    entity: string;
    start_date: string;
    date_of_death: string;
    jurisdiction: string;
	designation_salutation: string;
	first_name: string;
	middle_name: string;
	last_name: string;
	suffix: string;
	known_as: string;
	gender: string;
	gender_identity: string[];
	gender_identity_other: string;
	date_of_birth: string;
	tax_id: string;
    mailing_address_1: string;
    mailing_address_2: string;
    mailing_address_3: string;
    mailing_country: string;
    mailing_city: string;
    mailing_state: string;
    mailing_postal_code: string;

    // phones


    home_phone_country_code: string;
    home_phone_area_code: string;
    home_phone_number: string;
    home_phone_formated: string;
    home_phone_extension: string;

    mobile_phone_country_code: string;
    mobile_phone_area_code: string;
    mobile_phone_number: string;
    mobile_phone_formated: string;
    mobile_phone_extension: string;

    personal_email_address: string;
    office_email_address?: string;
    business_phone_formated?: string; 

    matched_person: string;
    checkbox1: boolean;
    checkbox2: boolean;
}
